import React from "react";
import { styled } from '@mui/system';

import { Button } from 'primereact/button';

import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import { PrimeIcons } from 'primereact/api';
import 'primereact/resources/themes/lara-light-indigo/theme.css'; // theme
import 'primereact/resources/primereact.css';

import "../../../styles/theme/aistheme.css";
import "../../../styles/theme/sharedThemeOverride.css";
import { MenuBlockItem } from "../../../globals/data/menuData/menuData";
import MenuDisplayItem from "../items/menuDisplayItem";



const GeneralButtonStyle = {
  display: "flex",
  flexDirection: "row",
  flexGrow: 1,
  color: "black",
  height: "35px",
  marginTop: "auto",
  marginBottom: "auto",
  width: "35px",
  backgroundColor: "gray",
  maxHeight: "35px !Important",
  maxWidth: "35px  !Important",
  minHeight: "35px !Important",
  minWidth: "35px  !Important",
  padding: "0px"
};


const WrapperContainer = styled("div")(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    flex-grow: 0;
    background-color: pink;    
    `
);




const DisplayLabelContainer = styled("div")(
  ({ theme }) => `
    color: #000000;
    
    margin-top: 10px;
    margin-bottom: auto;
    margin-left: 10px;
    margin-right: 0px;
    display: flex;
    flex-direction: row;

    flex-grow: 0;
    justify-content: flex-start;
    align-items: center;
  
    font-family: 'poppins';
    font-weight: 400;
    font-size: calc(16px + (20 - 16) * ((100vw - 1366px) / (2560 - 1366)));
  
  
    `
);


const ItemOutterContainer = styled("div")(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    flex-grow: 0;
    background-color: orange;
    margin-top:5px;

    `
);



const ItemsContainer = styled("div")(
  ({ theme }) => `
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    // background-color: lightblue;

    
    `
);





interface HeaderProps {
  menuBlockItem: MenuBlockItem
}


function menuDisplayBlock(props: HeaderProps) {

  //Our goal here is to show a title for the block and then the collection of 
  //menu items

  return (
    <WrapperContainer id="mennu block WrapperContainer">

      <DisplayLabelContainer>
        {props.menuBlockItem.title}
      </DisplayLabelContainer>

      <ItemOutterContainer>
        {
          (props.menuBlockItem.menuItemCollection.map((item, index) => {
            return (
              <ItemsContainer
                key={index}
              >
                <MenuDisplayItem
                  menuItem={item}
                />
              </ItemsContainer>

            )
          }))
        }
      </ItemOutterContainer>


    </WrapperContainer>

  )
}


export default menuDisplayBlock;